var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"/glossary/"}},[_c('span',[_c('Icon',{attrs:{"i":"file"}}),_vm._v(" Click for Glossary of Terms")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }